import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const PostManagementList = lazy(
  () => import('@components/Group/Portfolio/PostManagementList')
);

const PostManagement = () => {
  return (
    <ApiErrorBoundary>
      <Suspense fallback={<div>불러오는중 입니다....</div>}>
        <PostManagementList />
      </Suspense>
    </ApiErrorBoundary>
  );
};

export default PostManagement;
